import React from "react";
import PropTypes from "prop-types";

function ConnectBank({
  className,
  style,
  fill,
  dotFill,
  innerFill,
  opacity,
  defaultWidth,
  defaultHeight
}) {
  return (
    <>
      <svg
        viewBox="0 0 512 512"
        width={style && style.width ? style.width : defaultWidth}
        height={style && style.width ? style.height : defaultHeight}
        style={style}
        className={`hovered-paths ${className}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill={fill}>
          <circle
            cx="304"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <path
            d="M128 16h128l-8 40H136zM328 335.91v.09h-4c1.34 0 2.67-.03 4-.09z"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <path
            d="M256 16l-8 40H136l-8-40z"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="304"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <path
            d="M328 335.91v.09h-4c1.34 0 2.67-.03 4-.09z"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="360"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="416"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <path
            d="M328 335.91v.09h-4c1.34 0 2.67-.03 4-.09z"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="360"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="304"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
          <circle
            cx="416"
            cy="232"
            r="16"
            data-original={fill}
            class="active-path"
            data-old_color={fill}
            fill={dotFill}
          />
        </g>
        <g fill="#004fac">
          <path
            d="M152 456H96a8 8 0 000 16h56a8 8 0 000-16zM184 456h-8a8 8 0 000 16h8a8 8 0 000-16z"
            data-original="#004FAC"
            class="hovered-path"
            data-old_color="#004FAC"
            fill={innerFill}
          />
          <path
            d="M356 128a108.925 108.925 0 00-20 1.86V48a40.04 40.04 0 00-40-40H88a40.04 40.04 0 00-40 40v416a40.04 40.04 0 0040 40h208a40.04 40.04 0 0040-40V344s22.91-.03 24.31-.1A107.993 107.993 0 00356 128zM246.24 24l-4.8 24h-98.88l-4.8-24zM320 464a24.032 24.032 0 01-24 24H88a24.032 24.032 0 01-24-24V48a24.032 24.032 0 0124-24h33.44l6.72 33.57A7.99 7.99 0 00136 64h112a7.99 7.99 0 007.84-6.43L262.56 24H296a24.032 24.032 0 0124 24v86.18A108.188 108.188 0 00248 236a106.851 106.851 0 0025.85 70.13l-45.43 22.71A8 8 0 00232 344h88zm102.26-164.17a91.56 91.56 0 01-62.62 28.09c-1.21.05-93.75.08-93.75.08l24.77-12.38a8.009 8.009 0 001.93-12.96 92 92 0 11129.67-2.83z"
            data-original="#004FAC"
            class="hovered-path"
            data-old_color="#004FAC"
            fill={innerFill}
          />
          <path
            d="M360 208a24 24 0 1024 24 24.028 24.028 0 00-24-24zm0 32a8 8 0 118-8 8.009 8.009 0 01-8 8zM304 208a24 24 0 1024 24 24.028 24.028 0 00-24-24zm0 32a8 8 0 118-8 8.009 8.009 0 01-8 8zM416 208a24 24 0 1024 24 24.028 24.028 0 00-24-24zm0 32a8 8 0 118-8 8.009 8.009 0 01-8 8z"
            data-original="#004FAC"
            class="hovered-path"
            data-old_color="#004FAC"
            fill={innerFill}
          />
        </g>
      </svg>
    </>
  );
}

ConnectBank.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  dotFill: PropTypes.string,
  innerFill: PropTypes.string,
  opacity: PropTypes.number
};

ConnectBank.defaultProps = {
  className: undefined,
  defaultHeight: 512,
  defaultWidth: 512,
  fill: "#57a4ff",
  dotFill: "#37f6cc",
  innerFill: "#010d0a",
  opacity: 0.5
};

export default ConnectBank;
